// web/src/screens/Invite.tsx — /invite/:token (portal spec 13). Standalone like Login: stash the token, then sign in;
// AppShell accepts it after login (POST /v1/invites/accept).
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { isSignedIn, login } from '../lib/auth';
import { Icon } from '../components/Icon';
import { BRAND } from '../lib/brand';

export const INVITE_KEY = 'ypd_invite';

export function Invite() {
  const { token } = useParams();
  useEffect(() => {
    if (token) sessionStorage.setItem(INVITE_KEY, token);
    sessionStorage.removeItem('next'); // land on Home after sign-in, not on a stale ?next=
    if (isSignedIn()) window.location.replace('/'); // AppShell accepts the stored token (mock: always signed in)
    else void login();
  }, [token]);
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-bg px-6 text-center">
      <span className="flex size-12 items-center justify-center rounded-lg bg-run text-runink"><Icon name="rocket" size={24} /></span>
      <h1 className="font-head text-xl text-ink">Welcome to {BRAND.name}</h1>
      <p className="max-w-sm text-sm text-muted">Taking you to sign in. Create your account with any email you like.</p>
      <div className="flex items-center gap-2 text-sm text-muted">
        <Icon name="loader" size={16} className="animate-spin" />One moment…
      </div>
    </div>
  );
}
